export const validateEmail = async (email) => {
    const response = await request
        .get("https://api.bright-plans.com/denticalc/scoreEmail.php?email=" + email)
        .withCredentials(false)
        .set("accept", "application/json");
    
    if (response && response.body) return response.body.valid;
    return false;
};

export const callSubscribeWebhook = (email) => {
    request
        .post("https://newslettersrvc.planmaster.hu")
        .send({
            email: email,
        })
        .withCredentials(false)
        .set("accept", "text/html")
        .then((resp) => {
            console.log(resp);
        })
        .catch((error) => {
            console.error(error);
            captureException(error);
        });
};

export const callUpdateWebhook = (email, field, value) => {
    request
        .put("https://newslettersrvc.planmaster.hu")
        .send({
            email: email,
            field: field,
            value: value,
        })
        .withCredentials(false)
        .set("accept", "text/html")
        .then((resp) => {
            console.log(resp);
        })
        .catch((error) => {
            console.error(error);
            captureException(error);
        });
};
